// @module CCAW.OrderTerms.Consent
define("CCAW.OrderTerms.Consent.View", [
  "ccaw_orderterms_consent.tpl",
  "Backbone",
], function (ccaw_orderterms_consent_tpl, Backbone) {
  "use strict";

  // @class CCAW.OrderTerms.Consent.View @extends Backbone.View
  return Backbone.View.extend({
    template: ccaw_orderterms_consent_tpl,

    showOrderTerms: null,

    initialize: function initialize(options) {
      var self = this;
      this.showOrderTerms = options.showOrderTerms || false;

      var checkout = options.container.getComponent("Checkout");
      if (checkout) {
        checkout.on("afterShowContent", function () {
          checkout.getCurrentStep().then(function (step) {
            if (step.url === "review") {
              self.showOrderTerms = true;
              self.render();
            }
          });
        });
      }
    },

    events: {
      'click [data-action="ccaw_order_terms_agreement"]':
        "orderTermsCheckHandler",
    },

    bindings: {},

    childViews: {},

    //@method getContext @return CCAW.OrderTerms.Consent.View.Context
    getContext: function getContext() {
      return {
        showOrderTerms: this.showOrderTerms,
        urlPrefix:
          "https://www.prod-ccaw.store/sca-dev-2023-2-0/checkout.ssp?#",
      };
    },

    orderTermsCheckHandler: function orderTermsCheckHandler(e) {
      if (e && e.target && e.target.checked) {
        $('button[data-action="submit-step"]').prop("disabled", false);
      } else {
        $('button[data-action="submit-step"]').prop("disabled", true);
      }
    },
  });
});
